const stepsOrder = [
    'C1',
    'F1',
    'C2',
    'C14',
    'take_door_picture',
    'C4',
    'C5',
    'F2',
    'F10',
    'C8',
    'take_sticker_picture',
    'quotation',
    'F3',
    'F8',
    'C9',
    'F4',
    'C13',
    'C10',
    'C15',
    'C16',
    'C11',
    'C12',
    'F9',
];

export default {
    stepIsAfterOrSameAs(stepA, stepB, errorReportingClient) {
        const indexOfStepA = stepsOrder.indexOf(stepA);
        if (indexOfStepA === -1) {
            errorReportingClient.notify(new Error(`step [${stepA}] is not in stepsOrder array`));
            return false;
        }
        const indexOfStepB = stepsOrder.indexOf(stepB);
        if (indexOfStepB === -1) {
            errorReportingClient.notify(new Error(`step [${stepB}] is not in stepsOrder array`));
            return false;
        }
        return indexOfStepA >= indexOfStepB;
    }
}
